import { render } from "./modifyPwdModal.vue?vue&type=template&id=7c06b6ab&scoped=true"
import script from "./modifyPwdModal.vue?vue&type=script&lang=js"
export * from "./modifyPwdModal.vue?vue&type=script&lang=js"

import "./modifyPwdModal.vue?vue&type=style&index=0&id=7c06b6ab&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c06b6ab"]])

export default __exports__